export default __webpack_public_path__ + "static/media/calculator_only.85e5e878.svg";